import React from "react"
import Styles from "./uploadTips.less"
import ShowReUpLoad from "../../../function/hooks/showReUpLoad"
import {VIEWTYPE} from "../../util/utilData"

interface UploadTipsProps {
    text: Array<JSX.Element>
    type: string
    viewType: string
}

export function isValidKey(key: string | number | symbol, object: object): key is keyof typeof object {
    return key in object
}

export const UploadTips: React.FunctionComponent<UploadTipsProps> = ({text, type, viewType}) => {
    const showReUpLoad = ShowReUpLoad()

    let isShowTip = {
        display: isValidKey(type, showReUpLoad.value) && showReUpLoad.value[type] ? "flex" : "none",
        // display: "flex",
    }
    return (
        <div style={{display: viewType == VIEWTYPE.CREATE ? "flex" : "none"}} className={Styles.tipsNavStatusBox}>
            <div style={isShowTip} className={Styles.navBox}>
                {text}
            </div>
        </div>
    )
}
